import { useAppSelector } from 'js/store/hooks';

export function useShowAdvancedTimeline() {
  return useAppSelector(state => state.ui.newTimeline);
}
